<template>
    <nav id="nav" class="navbar navbar-expand-lg border-bottom-0 py-2 py-lg-0" style="background: var(--primary-color);">
        <div class="container-fluid px-3 px-lg-5">
            <router-link :to="{ name: 'Home'}" class="navbar-brand me-lg-4">
                <img src="/images/logo.png" class="img-fluid" style="max-height: 45px; width: auto; padding: 0; filter: brightness(0) invert(1);" :alt="$t('altsImgs.logoDiverse')">
            </router-link>

            <button class="navbar-toggler btnMenu border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-lg-center">
                    <li class="nav-item">
                        <router-link activeClass="active-link" :to="{ name: 'Home'}">
                            <a class="nav-link fw-semibold text-white" @click="closeMenu()" href="#top">{{ $t('links.home') }}</a>
                        </router-link >
                    </li>

                    <li class="nav-item">
                        <router-link activeClass="active-link" :to="{ name: 'Mission'}">
                            <a class="nav-link fw-semibold text-white" @click="closeMenu()">{{ $t('links.mission') }}</a>
                        </router-link>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle fw-semibold text-white" 
                            href="#section_5" 
                            id="navbarLightDropdownMenuLink" 
                            role="button" 
                            data-bs-toggle="dropdown" 
                            data-bs-auto-close="true"
                            aria-expanded="false">
                            {{ $t('links.services') }}
                        </a>

                        <ul class="dropdown-menu dropdown-menu-light shadow-sm border-0 mt-2" aria-labelledby="navbarLightDropdownMenuLink" >
                            <li v-for="(service, index) in services" :key="index">
                                <router-link activeClass="active-link"  :to="service.routeTo || { name: 'Service', params: { service: service.nameParams }}">
                                    <a class="dropdown-item fw-medium py-2" @click="closeMenu()" :href="`/service/${service.nameParams}`">
                                        <template v-if="service.id == 5">
                                            {{ $i18n.locale == 'en' ? 'Hormone Replacement' : service.labelPtBR }}
                                        </template>
                                        <template v-else>
                                            {{ $i18n.locale == 'pt_BR' ? service.labelPtBR : service.labelEn  }}
                                        </template>
                                    </a>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item">
                        <router-link activeClass="active-link" :to="{ name: 'Payment Plans'}">
                            <a class="nav-link fw-semibold text-white" @click="closeMenu()">{{ $t('links.paymentPlans') }}</a>
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="{ name: 'Home'}" v-scroll-to="'#section_contact'">
                            <a class="nav-link fw-semibold text-white" @click="closeMenu()" href="#section_contact">{{ $t('links.contact') }}</a>
                        </router-link>
                    </li>
                </ul>

                <ul class="navbar-nav ms-auto align-items-lg-center flex-row justify-content-center gap-3 mt-3 mt-lg-0 pb-2 pb-lg-0">
                    <li class="nav-item">
                        <a href="https://wa.me/17542761746" target="_blank" class="nav-link text-white p-0">
                            <i class="bi-whatsapp fs-5"></i>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="https://diversecarenow.as.me/schedule/6a240cde" target="_blank" class="nav-link text-white p-0">
                            <i class="bi-calendar-event fs-5"></i>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="https://www.instagram.com/diversecarenow/?igshid=YmMyMTA2M2Y%3D" target="_blank" class="nav-link text-white p-0">
                            <i class="bi-instagram fs-5"></i>
                        </a>
                    </li>
                    <li class="nav-item d-flex align-items-center dropdown ms-lg-3">
                        <a class="nav-link dropdown-toggle p-0 text-white d-flex align-items-center" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                            <span :class="currentLanguage.flag" class="flag-icon-header" style="font-size: 24px; line-height: 24px;"></span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2" aria-labelledby="navbarDropdown" style="min-width: 150px; position: absolute; top: 100%; bottom: auto; right: 0; left: auto;">
                            <li v-for="lang in languages" :key="lang.code">
                                <a class="dropdown-item fw-medium d-flex align-items-center gap-2 py-2" href="#" @click.prevent="setLocale(lang)">
                                    <span :class="lang.flag" class="flag-icon-dropdown mb-0" style="font-size: 18px; line-height: 18px; margin-right: 0;"></span> {{ lang.name }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
import { servicesContent } from './../pages/ServicesDetails/ServicesContent'
import 'flag-icons/css/flag-icons.min.css';
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import { LANGUAGES } from './../common/constants';

export default {
  name: 'NavLayout',
  setup() {
    const services = servicesContent
    const { locale } = useI18n({ useScope: 'global' });

    const languages = ref([
        { code: LANGUAGES.EN, name: 'English', flag: 'fi fi-us' },
        { code: LANGUAGES.PT_BR, name: 'Português', flag: 'fi fi-br' },
        { code: LANGUAGES.ES, name: 'Español', flag: 'fi fi-cu' }
    ]);

    const currentLanguage = computed(() => {
        return languages.value.find(lang => lang.code === locale.value) || languages.value[0];
    });

    const setLocale = (lang) => {
        if (lang && lang.code) {
            locale.value = lang.code;
        }
    }

    if (!locale.value) {
        locale.value = LANGUAGES.EN;
    }

    const closeMenu = () => {
        let collapse = document.querySelector('.show');
        if(collapse){
            let btnMenu = document.querySelector('.btnMenu');
            btnMenu.click();
        }
    }
    
    return {
        closeMenu,
        services,
        setLocale,
        locale,
        languages,
        currentLanguage
    }
  }
}
</script>
<style scoped>
.navbar-nav .nav-link.text-white:hover {
    color: var(--secondary-color) !important;
}
.active-link .nav-link {
    color: var(--secondary-color) !important;
}
.navbar-toggler .navbar-toggler-icon {
    background-image: none !important;
}
.navbar-toggler .navbar-toggler-icon,
.navbar-toggler .navbar-toggler-icon::before,
.navbar-toggler .navbar-toggler-icon::after {
    background: var(--white-color) !important;
}
@media (max-width: 991px) {
    .navbar-collapse {
        background: var(--primary-color);
        padding: 1rem;
        border-radius: 8px;
        margin-top: 10px;
    }
    .dropdown-menu {
        background: var(--white-color);
    }
    .navbar-nav.ms-auto {
        margin-left: 0 !important;
    }
}
</style>